export default __webpack_public_path__ + "static/media/Montserrat-Bold.079ca05d.ttf";